import React, { useState, useEffect } from 'react';
import './index.scss';
import { useHistory } from 'react-router-dom';

import News from "../../components/templates/news/News";
import {Routes} from "../../../routes";
import CategoryService from "../../shared/services/CategoryService";
import PSLoading from "../../components/PSLoading";
import EntityService from "../../shared/services/EntityService";
import {ModelNews} from "../../shared/model/ModelNews";

export default function NewsPage() {

  const [showModalNewCategory, setShowModalNewCategory] = useState(false);
  const history = useHistory();
  const [newCategory, setNewCategory] = useState({description: '', favorite: false});
  const [loading, setLoading] = useState(true);
  const [loadingSave, setLoadingSave] = useState(false);
  const [loadingAction, setLoadingAction] = useState(-1);
  const [listCategories, setListCategories] = useState([]);
  const [listNews, setListNews] = useState([]);
  const [currentIdCategory, setCurrentIdCategory] = useState(-1);


  const createNews= ( )=>{
    history.push(Routes.CMS_NEWS_ITEM);
  };


  const loadNews = async () => {
    try{
      setLoading(true);
      const response = await EntityService.responseGetEntity();
      const newsModel =response.data.map((data) => new ModelNews(data));
      setListNews([...newsModel]);
      setLoading(false);
    }catch (error){
      setLoading(false);
    }
  };

  const deleteNews =  async (id) => {
    try{
      setLoadingAction(id);
      await EntityService.responseDeleteEntity(id);
      const filterNews = listNews.filter(item => item.id !== id)
      setListNews([...filterNews]);
      setLoadingAction(-1);
    }catch (error){
      setLoadingAction(-1);
    }
  };

  const editNews =  async (news, id) => {
    try{
      setLoadingAction(id);
      await EntityService.responseEditEntity(news, id);
      setLoadingAction(-1);
    }catch (error){
      setLoadingAction(-1);
    }
  };

  const changeCategoryNews = async (value, news, index) => {
    const newsEdit = {...news, idCategory : value };
    let formData = new FormData();
    formData.append('idEntity', news.idEntity);
    formData.append('idCategory', value);
    formData.append('title', news.title);
    formData.append('description', news.description);
    await editNews(formData, news.id);

    listNews[index] = newsEdit;
    setListNews([...listNews]);
  };

  const onChangeCategory = (value, property) => {
    setNewCategory({...newCategory,[property]: value })
  };

  const saveCategory =  async () => {
    try{
      if(newCategory && newCategory.description){
        setLoadingSave(true);
        await CategoryService.responseSaveCategory(newCategory);
        setLoadingSave(false);
        setShowModalNewCategory(false);
        setNewCategory(null);
        await loadCategory();
      }

    }catch (error){
      setLoadingSave(false);
    }
  };

  const editCategory =  async () => {
    try{
      if(newCategory.description){
        setLoadingSave(true);
        await CategoryService.responseUpdateCategory(currentIdCategory,
          {
            ...newCategory,
            idOrganization: 1,
          }
        );
        setLoadingSave(false);
        setShowModalNewCategory(false);
        setNewCategory(null);
        await loadCategory();
      }

    }catch (error){
      setLoadingSave(false);
    }
  };

  const loadCategory =  async () => {
    try{
      const response = await CategoryService.responseGetCategory();
      setLoading(false);
      setListCategories([...response.data]);
    }catch (error){
      setLoading(false);
    }
  };

  const deleteCategory =  async (id) => {
    try{
      await CategoryService.responseDeleteCategory(id);
      const filterCategories = listCategories.filter(item => item.id !== id)
      setListCategories([...filterCategories]);
    }catch (error){
    }
  };

  useEffect(()=>{
    loadNews();
    loadCategory();
  },[]);

  return(
    <div>
      {
        loading ?
          <div className="d-flex-center ">
            <PSLoading color='red'/>
          </div>:
          <News
            listNews={currentIdCategory ===-1 ? listNews : listNews.filter(item=> item.idCategory===currentIdCategory)}
            listCategories={listCategories}
            showModalNewCategory = {showModalNewCategory}
            onCreateNewCategory = {()=>setShowModalNewCategory(true)}
            onCloseModal = {()=>setShowModalNewCategory(false)}
            onCreateNews = {createNews}
            onEditNews = {editNews}
            saveCategory ={saveCategory}
            editCategory ={editCategory}
            loadingSave={loadingSave}
            loadingAction={loadingAction}
            onChangeCategory ={onChangeCategory}
            currentIdCategory={currentIdCategory}
            selectCurrentIdCategory = {(id)=>setCurrentIdCategory(id)}
            deleteNews={deleteNews}
            onChangeCategoryNews = {changeCategoryNews}
            deleteCategory={deleteCategory}
            newCategory={newCategory}
            setCategory = {(value)=>setNewCategory(value)}
            editNews = {(news)=>history.push(`${Routes.CMS_NEWS_ITEM}/${news.id}`)}
          />
      }
    </div>
  )
}